"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ProvidersDesktop_1 = __importDefault(require("./ProvidersDesktop"));
var ProvidersMobile_1 = __importDefault(require("./ProvidersMobile"));
var apps_shared_1 = require("@l2p/apps-shared");
var ProvidersExpandedState = function (_a) {
    var cancelViewAll = _a.cancelViewAll;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (react_1.default.createElement("div", null, Object.keys(breakpoints).length > 0 && breakpoints.mobile ? (react_1.default.createElement(ProvidersMobile_1.default, { cancelViewAll: cancelViewAll })) : (react_1.default.createElement(ProvidersDesktop_1.default, null))));
};
exports.default = ProvidersExpandedState;
